<template>
  <div class="text-center text-secondary my-2">
    <b-spinner class="align-middle"></b-spinner>
    <slot name="body">
      <strong>Loading...</strong>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'loading-spinner',
  };
</script>
